// extracted by mini-css-extract-plugin
export default {"tag":"Whb9Kw9","tag--default":"DqIxyDs","tag--disabled":"V4C5nSj","tag--lime":"J8QH0jN","tag__button":"EJ3ldbu","tag__icon":"FNQGDm6"};